import { Component, Input, InputSignal, Signal, WritableSignal, computed, inject, input, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { IcfDescriptionPipe } from '../../pipes/icf-description.pipe';
import { AssessmentsService } from '../../services/assessments.service';
import { IcfCategory } from '../../services/model';

@Component({
  selector: 'app-icf-box-large',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, IcfDescriptionPipe],
  templateUrl: './icf-box-large.component.html',
  styleUrl: './icf-box-large.component.scss',
})
export class IcfBoxLargeComponent {
  @Input() icfCategory?: IcfCategory;

  valuePercent: InputSignal<number> = input(0);
  icfSelectedByUser: InputSignal<number> = input(0); // -1 -> kein Wert gewählt

  private readonly assessmentService: AssessmentsService = inject(AssessmentsService);

  valueIcf: Signal<number> = computed(() => {
    const value = this.valuePercent();
    for (const level of this.damageLevels) {
      if (value >= level.min && value <= level.max) {
        return level.icf;
      }
    }
    return 4;
  });

  valuePercentEven: Signal<number> = computed(() => {
    const percent = this.valueIcf() * 25;
    return percent > 100 ? 100 : percent;
  });

  boxes: Signal<Array<{ filled: boolean; last?: boolean }>> = computed(() => {
    const boxes: Array<{ filled: boolean; last?: boolean }> = [];
    const filledBoxesCount = this.icfSelectedByUser();
    for (let index = 0; index < 5; index++) {
      if (filledBoxesCount > -1 && index <= filledBoxesCount) {
        const last = index === filledBoxesCount;
        boxes.push({ filled: true, last });
      } else {
        boxes.push({ filled: false });
      }
    }

    return boxes;
  });

  icfColor: Signal<string> = computed(() => {
    const icf = this.icfSelectedByUser();
    if (icf > -1) {
      const level = this.damageLevels.find(level => icf === level.icf);
      if (level) {
        return level.color;
      }
    }
    return 'white';
  });

  damageLevels = [
    { icf: 4, min: 96, max: 100, color: '#F4856D' }, // Schädigung voll ausgeprägt
    { icf: 3, min: 50, max: 95, color: '#EEB27B' }, // Schädigung erheblich ausgeprägt
    { icf: 2, min: 25, max: 49, color: '#E8E596' }, // Schädigung mäßig ausgeprägt
    { icf: 1, min: 5, max: 24, color: '#F4F7D0' }, // Schädigung leicht ausgeprägt
    { icf: 0, min: 0, max: 4, color: '#b1dd5f7d' }, // Schädigung nicht vorhanden
  ];

  getBackgroundColor(): string {
    for (const level of this.damageLevels) {
      if (this.valuePercent() >= level.min && this.valuePercent() <= level.max) {
        return level.color;
      }
    }
    return 'white'; // Standardfarbe, falls keine Bedingung zutrifft
  }

  selectGeneratedIcf() {
    // this.icfSelectedByUser.set(this.valueIcf());
    this.persistSelection(this.valueIcf());
  }
  select(index: number) {
    // this.icfSelectedByUser.set(index);
    this.persistSelection(index);
  }
  remove() {
    // this.icfSelectedByUser.set(-1);
    this.persistSelection(-1);
  }

  persistSelection(icfScore: number) {
    this.assessmentService.createOrUpdateReportNote({
      icfScoreSelected: icfScore,
      icfCategory: this.icfCategory!,
    });
  }
}
